import { render, staticRenderFns } from "./Type4.vue?vue&type=template&id=5dd34fba&scoped=true"
import script from "./Type4.vue?vue&type=script&lang=js"
export * from "./Type4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd34fba",
  null
  
)

export default component.exports